module.exports = __webpack_public_path__ + "static/media/man-4.bef3aabb.svg";